module.exports = __webpack_public_path__ + "media/images/emblems/Thun-coat_of_arms-b03fe4d62292c9ceb81c185cc58cced7.svg";